window.addEventListener("load", function(event) {
    let applyBtn = document.querySelector("#apply-discount-btn");
    let discountCodeError = document.querySelector("#discount-code-error");
    let discountCodeInput = document.querySelector("#discount-code-input");
    let totalCartSelector = document.querySelector(".total");
    let discountDiv = document.querySelector("#discount-div");
    let appliedDiscounts = [];
    let originalTotalCart = 0;

    const observerConfig = { childList: true, subtree: true };

    function formatPrice(price, currencySymbol) {
        let formattedPrice = (Math.round(price * 100) / 100).toFixed(2);
        return `${currencySymbol} ${formattedPrice}`;
    }

    function initializeDiscounts() {
        if (sessionStorage.discountCodes) {
            let storedDiscounts = JSON.parse(sessionStorage.discountCodes);
            storedDiscounts.forEach(discount => {
                if (!isDiscountAlreadyApplied(discount.code) && !discount.title.includes("Gift")) {
                    appliedDiscounts.push(discount);
                }
            });
            if(originalTotalCart != 0){
              reapplyAllDiscounts();
            }
            if (discountDiv) {
                updateDiscountDiv(appliedDiscounts);
            }
        }
    }

    function hideLoader() {
        document.querySelectorAll('.loading-overlay').forEach(loader => {
            loader.classList.add('hidden');
        });
    }
    function calculateTotal(cartData) {
        return cartData.total_price;
    }
    function fetchCartTotal() {
        fetch('/cart.js', {}).then(res => res.json())
        .then(cartData => {
            originalTotalCart = calculateTotal(cartData);
            reapplyAllDiscounts();
        });
    }

    fetch('/cart.js', {}).then(res => res.json())
    .then(cartData => {
        originalTotalCart = cartData.total_price;
        if (sessionStorage.returnedFromCheckout) {
            sessionStorage.removeItem('discountCodes');
            sessionStorage.removeItem('returnedFromCheckout');
            appliedDiscounts = []; // Clear applied discounts when returning from checkout
            reapplyAllDiscounts(); // Reapply discounts to update the total
            updateDiscountDiv(appliedDiscounts); // Update discount div
            updateMiniCartDiscountDiv(appliedDiscounts); // Update mini cart discount div
        }
        initializeDiscounts();
        updateDiscountDiv(appliedDiscounts);
        updateMiniCartDiscountDiv(appliedDiscounts);
        hideLoader();
    });
    fetchCartTotal(); // Initial fetch to get the total cart price

    if (applyBtn) {
        applyBtn.addEventListener("click", function(e){
            e.preventDefault();
            applyDiscount(discountCodeInput.value, true);
        });
    }

    function applyDiscount(code, showError) {
        if (isDiscountAlreadyApplied(code)) {
            if (showError) {
                discountCodeError.innerHTML = "This discount code has already been applied.";
            }
            return;
        }
        if (applyBtn) {
            applyBtn.innerHTML = "APPLYING <div class='loader'></div>";
            applyBtn.style.pointerEvents = "none";
        }
        fetch("/payments/config", { "method": "GET" })
        .then(response => response.json())
        .then(data => {
            const checkout_json_url = '/wallets/checkouts/';
            const authorization_token = btoa(data.paymentInstruments.accessToken);
            fetch('/cart.js').then(res => res.json())
            .then(cartData => {
                let body = { 
                    "checkout": { 
                        "country": Shopify.country, 
                        "discount_code": code, 
                        "line_items": cartData.items, 
                        'presentment_currency': Shopify.currency.active 
                    } 
                };
                fetch(checkout_json_url, {
                    headers: {
                        "accept": "*/*", 
                        "cache-control": "no-cache",
                        "authorization": "Basic " + authorization_token,
                        "content-type": "application/json, text/javascript",
                        "pragma": "no-cache",
                        "sec-fetch-dest": "empty",
                        "sec-fetch-mode": "cors",
                        "sec-fetch-site": "same-origin"
                    },
                    referrerPolicy: "strict-origin-when-cross-origin",
                    method: "POST",
                    mode: "cors",
                    credentials: "include",
                    body: JSON.stringify(body)
                })
                .then(response => response.json())
                .then(data => {
                    const currencySymbol = Shopify.currency.active;
                    if (data.checkout && data.checkout.applied_discounts.length > 0) {
                        const discount = data.checkout.applied_discounts.find(d => !d.title.includes("Gift"));
                        if (discount) {
                            const discountAmount = parseFloat(discount.amount) * 100;
                            appliedDiscounts.push({ code: code, title: code, amount: discountAmount });
                            sessionStorage.setItem("discountCodes", JSON.stringify(appliedDiscounts));
                            if (discountDiv) {
                                updateDiscountDiv(appliedDiscounts);
                            }
                            updateMiniCartDiscountDiv(appliedDiscounts);
                            reapplyAllDiscounts();
                            discountCodeInput.value = '';
                        } else {
                            if (showError) {
                                discountCodeError.innerHTML = "Please Enter Valid Discount code or Gift card.";
                            }
                        }
                    } else {
                        if (showError) {
                            discountCodeError.innerHTML = "Please Enter Valid Discount code or Gift card.";
                        }
                    }
                }).finally(function() {
                    applyBtn.innerHTML = "APPLY";
                    applyBtn.style.pointerEvents = "all";
                });
            });
        });
    }


    function isDiscountAlreadyApplied(code) {
        return appliedDiscounts.some(discount => discount.code === code);
    }

    function reapplyAllDiscounts() {
        let updatedTotal = originalTotalCart;
        const currencySymbol = Shopify.currency.active;

        appliedDiscounts.forEach(discount => {
            if (!discount.title.includes("Gift")) {
                updatedTotal -= discount.amount;
            }
        });

        updateCartTotal(updatedTotal, currencySymbol);
        updateMiniCartTotal(updatedTotal, currencySymbol);
    }

    function updateCartTotal(totalPrice, currencySymbol) {
        const formattedTotalPrice = formatPrice(totalPrice / 100, currencySymbol);
        if (totalCartSelector) {
            totalCartSelector.innerHTML = `${formattedTotalPrice}`;
        }
    }

    function updateMiniCartTotal(totalPrice, currencySymbol) {
        const formattedTotalPrice = formatPrice(totalPrice / 100, currencySymbol);
        let miniCartSubtotal = document.querySelector("#mini-cart-subtotal");
        if (miniCartSubtotal) {
            miniCartSubtotal.innerHTML = `${formattedTotalPrice}`;
        } else {
            // Add a new div for mini cart total if not found
            let miniCartDiscountDiv = document.querySelector("#mini-cart-discount-div");
            if (miniCartDiscountDiv) {
                let newSubtotalDiv = document.createElement("div");
                newSubtotalDiv.id = "mini-cart-subtotal";
                newSubtotalDiv.innerHTML = `${formattedTotalPrice}`;
                miniCartDiscountDiv.parentNode.insertBefore(newSubtotalDiv, miniCartDiscountDiv.nextSibling);
            }
        }
    }

    function updateDiscountDiv(discounts) {
        discountDiv = document.querySelector("#discount-div"); // Ensure it's re-selected
        if (discountDiv) {
            if (discounts.length > 0) {
                let discountHTML = '<ul class="discounts list-unstyled" role="list" aria-label="Discounts">';
                discounts.forEach((discount, index) => {
                    if (!discount.title.includes("Gift")) {
                        discountHTML += `<li class="discounts__discount discounts__discount--end">
                                          <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-discount" viewBox="0 0 24 24"><path d="M10 2h4l8 8v4l-8 8h-4l-8-8v-4l8-8z"></path></svg>
                                         Discount: ${discount.title} (&#8211; <span class="money">${(discount.amount / 100).toFixed(2)} ${Shopify.currency.active}</span>)
                                         <button class="remove-discount-btn" data-index="${index}" style="margin-left: 10px;">X</button>
                                         </li>`;
                    }
                });
                discountHTML += '</ul>';
                discountDiv.innerHTML = discountHTML;

                document.querySelectorAll('.remove-discount-btn').forEach(button => {
                    button.addEventListener('click', function(e) {
                        e.stopPropagation();
                        let index = parseInt(this.getAttribute('data-index'));
                        removeCustomDiscount(index);
                    });
                });
            } else {
                discountDiv.innerHTML = '';
            }
        }
    }

    function updateMiniCartDiscountDiv(discounts) {
        let miniCartDiscountDiv = document.querySelector("#mini-cart-discount-div");
        if (miniCartDiscountDiv) {
            if (discounts.length > 0) {
                let discountHTML = '<ul class="discounts list-unstyled" role="list" aria-label="Discounts">';
                discounts.forEach((discount, index) => {
                    if (!discount.title.includes("Gift")) {
                        discountHTML += `<li class="discounts__discount discounts__discount--end">
                                          <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-discount" viewBox="0 0 24 24"><path d="M10 2h4l8 8v4l-8 8h-4l-8-8v-4l8-8z"></path></svg>
                                         Discount: ${discount.title} (&#8211; <span class="money">${(discount.amount / 100).toFixed(2)} ${Shopify.currency.active}</span> )
                                         <button class="remove-discount-btn" data-index="${index}" style="margin-left: 10px;">X</button>
                                         </li>`;
                    }
                });
                discountHTML += '</ul>';
                miniCartDiscountDiv.innerHTML = discountHTML;

                document.querySelectorAll('.remove-discount-btn').forEach(button => {
                    button.addEventListener('click', function(e) {
                        e.stopPropagation();
                        let index = parseInt(this.getAttribute('data-index'));
                        removeCustomDiscount(index);
                    });
                });

                let miniCartSubtotal = document.querySelector("#mini-cart-subtotal");
                if (miniCartSubtotal) {
                    updateMiniCartTotal(originalTotalCart, Shopify.currency.active);
                } else {
                    let newSubtotalDiv = document.createElement("div");
                    newSubtotalDiv.id = "mini-cart-subtotal";
                    newSubtotalDiv.innerHTML = `${formatPrice(originalTotalCart / 100, Shopify.currency.active)}`;
                    miniCartDiscountDiv.parentNode.insertBefore(newSubtotalDiv, miniCartDiscountDiv.nextSibling);
                    updateMiniCartTotal(originalTotalCart, Shopify.currency.active);
                }
            } else {
                miniCartDiscountDiv.innerHTML = '';
            }
        }
    }

    function removeCustomDiscount(index) {
        appliedDiscounts.splice(index, 1);
        sessionStorage.setItem("discountCodes", JSON.stringify(appliedDiscounts));
        reapplyAllDiscounts();
        if (discountDiv) {
            updateDiscountDiv(appliedDiscounts);
        }
        if (document.querySelector("#mini-cart-discount-div")) {
            updateMiniCartDiscountDiv(appliedDiscounts);
        }
    }

    function removeShopifyDiscount(discountTitle) {
        fetch('/cart/change.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                attributes: {
                    _discount_code: discountTitle
                }
            }),
        }).then(response => {
            if (response.ok) {
                window.location.reload();
            }
        }).catch(error => {
            console.error("Error removing discount:", error);
        });
    }

    function appendDiscountCodesToCheckout() {
        let discountCodes = appliedDiscounts.map(discount => discount.code);

        // Add discount codes from cart.discount applications
        let cartDiscountCodes = [];
        document.querySelectorAll('.cart-discount .discounts__discount').forEach(discountElement => {
            let discountText = discountElement.textContent.match(/Discount:\s*([^(\s]*)/);
            if (discountText) {
                cartDiscountCodes.push(discountText[1].trim());
            }
        });

        // Combine both discount sources
        discountCodes = discountCodes.concat(cartDiscountCodes);

        if (discountCodes.length > 0) {
            let encodedDiscountCodes = discountCodes.map(encodeURIComponent).join(',');
            let checkoutURL = `/checkout?discount=${encodedDiscountCodes}`;
            sessionStorage.setItem('returnedFromCheckout', true);
            window.location.href = checkoutURL;
        } else {
            window.location.href = '/checkout';
        }
    }

    let mainCartCheckoutBtn = document.querySelector('button[name="checkout"]');
    if (mainCartCheckoutBtn) {
        mainCartCheckoutBtn.addEventListener('click', function(event) {
            event.preventDefault();
            appendDiscountCodesToCheckout();
        });
    }

    function initializeMiniCart() {
        let miniCartCheckoutBtn = document.querySelector(".mini-cart button[name='checkout']");
        if (miniCartCheckoutBtn) {
            miniCartCheckoutBtn.addEventListener('click', function(event) {
                event.preventDefault();
                appendDiscountCodesToCheckout();
            });
        } else {
            setTimeout(initializeMiniCart, 500); // Retry after 500ms
        }
    }

    initializeDiscounts();
    initializeMiniCart();

    const observer = new MutationObserver(function(mutations) {
        observer.disconnect(); // Temporarily disable observer
        mutations.forEach(function(mutation) {
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                let miniCartDiscountDiv = document.querySelector("#mini-cart-discount-div");
                if (miniCartDiscountDiv) {
                    updateMiniCartDiscountDiv(appliedDiscounts);
                }
                let miniCartSubtotal = document.querySelector("#mini-cart-subtotal");
                if (miniCartSubtotal) {
                    reapplyAllDiscounts(); // Reapply discounts to update the total
                }
                fetchCartTotal(); // Fetch and update cart total
            }
            if (mutation.type === 'attributes' && mutation.attributeName === 'bucks-current') {
                let miniCartSubtotal = mutation.target;
                miniCartSubtotal.innerHTML = miniCartSubtotal.getAttribute('bucks-current');
            }
        });
        let miniCartSubtotal = document.querySelector("#mini-cart-subtotal");
        if (miniCartSubtotal) {
            observer.observe(miniCartSubtotal, observerConfig);
        }
    });

    observer.observe(document.body, observerConfig);

    setTimeout(function() {
        updateMiniCartDiscountDiv(appliedDiscounts);
        let miniCartSubtotal = document.querySelector("#mini-cart-subtotal"); // Ensure it's re-selected
        if (miniCartSubtotal) {
            miniCartSubtotal.innerHTML = miniCartSubtotal.getAttribute('bucks-current');
            reapplyAllDiscounts(); // Reapply discounts to update the total
        }
    }, 3000); // 3 seconds delay to ensure DOM is fully loaded
});
